import LogSender from "./logSender";
import { LogOptions } from "./model";

class DsLog {
  private static instance: DsLog;

  private field: { [s: string]: any };
  private tempLogs: any[];
  private logSender: LogSender;

  private constructor() {
    this.field = {};
    this.logSender = new LogSender();
    this.tempLogs = new Array<any>();
  }

  static getInstance() {
    if (!DsLog.instance) {
      DsLog.instance = new DsLog();
    }
    return DsLog.instance;
  }

  private pushDsLog(data: any) {
    this.logSender.pushLog({ data });
  }

  init({
    table,
    env,
    field,
    options
  }: {
    table: string;
    env: string;
    field: { [s: string]: any };
    options?: LogOptions;
  }) {
    if (table === undefined) {
      throw new Error("table undefined");
    }

    this.field = field;

    this.logSender.init(
      {
        env: env || "TEST",
        table
      },
      options
    ); // Options

    if (this.tempLogs.length > 0) {
      this.tempLogs.forEach(log => this.pushDsLog({ ...this.field, ...log }));
      this.tempLogs = [];
    }
  }

  log(logField: { [s: string]: any }) {
    // if (Object.keys(this.field).length === 0) {
    //   throw new Error("DsLog is not initialized");
    // }

    const timestamp = Date.now();
    const url = location.pathname + location.hash;
    const { ...defaultField } = this.field;
    const data = {
      timestamp,
      url,
      ...defaultField,
      ...logField
    };

    if (Object.keys(this.field).length === 0) {
      this.tempLogs.push(data);
    } else {
      this.pushDsLog(data);
    }
  }
}

export default DsLog.getInstance();
